import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CategoriesIcon from "@mui/icons-material/HomeOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import ContactEmergencyOutlinedIcon from "@mui/icons-material/ContactEmergencyOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import firebase from "firebase/app";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Avatar } from "@mui/material";
import Logo from "../../assets/logoN3_transparent.png";
import { useTheme } from "@mui/styles";
import { styled, alpha } from "@mui/material/styles";
import { logoutSuccess } from "../../redux/reducers/auth.reducer";
import { setFavouriteProducts } from "../../redux/reducers/favouriteProducts.reducer";
import Dropdown from "react-multilevel-dropdown";
import "./styles.css";
import {
  setSelectedEmirates,
  setSelectedRegion,
} from "../../redux/reducers/emiratesAndRegion.reducer";
import {
  setNotifications,
  setNotificationsProducts,
} from "../../redux/reducers/notificationsProducts.reducer";
import { setSelectedStores } from "../../redux/reducers/stores.reducer";
import NavBar from "./NavBar";
const drawerWidth = 240;
const Image = styled("img")(({ theme }) => ({
  width: 100,
  height: 80,
  resizeMode: "contain",
}));

function ResponsiveNewDrawer(props) {
  const { window, children } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [categories, setCategories] = React.useState([]);
  const [offers, setOffers] = React.useState([]);
  const userNotifications = useSelector(
    (state) => state.notificationsProducts.notificationsProducts
  );
  const userFavProducts = useSelector(
    (state) => state.favouriteProducts.products
  );
  const userMessagesCount = useSelector(
    (state) => state.messages.messagesCount
  );
  const userData = useSelector((state) => state.auth.user);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [routes, setRoutes] = React.useState([]);

  React.useEffect(() => {
    const getOffers = () => {
      firebase
        .firestore()
        .collection("offers")
        .get()
        .then((result) => {
          const data = result.docs.map((d) => ({
            ...d.data(),
            createdAt:
              d.data().createdAt && d.data().createdAt.toDate
                ? d.data().createdAt.toDate()
                : d.data().createdAt,
          }));
          setOffers(data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getOffers();
  }, []);

  React.useEffect(() => {
    const getCategories = () => {
      firebase
        .firestore()
        .collection("categories")
        .get()
        .then((result) => {
          const data = result.docs.map((d) => ({
            ...d.data(),
            createdAt:
              d.data().createdAt && d.data().createdAt.toDate
                ? d.data().createdAt.toDate()
                : d.data().createdAt,
          }));
          setCategories(data);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getCategories();
  }, []);

  const routesList = [
    {
      key: "screens.categories",
      icon: <CategoriesIcon />,
      route: "/",
      isDisabled: false,
    },
    {
      key: "screens.cart",
      icon: <ShoppingCartOutlinedIcon />,
      route: "/comparing-cart",
      isDisabled: false,
    },
    {
      key: "screens.comapres-list",
      icon: <BalanceOutlinedIcon />,
      route: "/compares-list",
      isDisabled: false,
    },
    {
      key: "screens.supermarketsAndGroceries",
      icon: <StorefrontOutlinedIcon />,
      route: "/stores",
      isDisabled: false,
    },
    {
      key: "screens.favourite",
      icon: <FavoriteOutlinedIcon />,
      route: "/favorites",
      isDisabled: false,
    },
    {
      key: "screens.notifications",
      icon: <NotificationsIcon />,
      route: "/notifications",
      isDisabled: false,
    },
    {
      key: "screens.offers",
      icon: <LocalOfferOutlinedIcon />,
      route: "/offers",
      isDisabled: false,
    },
    {
      key: "screens.contact-us",
      icon: <ContactEmergencyOutlinedIcon />,
      route: "/contact-us",
      isDisabled: false,
    },
    {
      key: "screens.logout",
      icon: <ExitToAppOutlinedIcon />,
      route: "/logout",
      isDisabled: false,
    },
    {
      key: "screens.translation",
      icon: <LanguageOutlinedIcon />,

      isDisabled: false,
    },
  ];
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const changeLanguage = async () => {
    const currentLanguage = i18n.language;
    const updateTo = currentLanguage && currentLanguage == "en" ? "ar" : "en";
    await i18n.changeLanguage(updateTo);
  };

  const handleLogout = async () => {
    await firebase.auth().signOut();
    dispatch(logoutSuccess());
    dispatch(setFavouriteProducts([]));
    dispatch(setSelectedEmirates([]));
    dispatch(setSelectedRegion([]));
    dispatch(setNotificationsProducts([]));
    dispatch(setNotifications([]));
    dispatch(setSelectedStores([]));
  };

  const unAuthrizedRoutes = ["/compares-list", "/notifications"];
  React.useEffect(() => {
    if (userData?.isAnonymous) {
      setRoutes(
        routesList?.filter(
          (item) => !unAuthrizedRoutes.includes(item.route ?? "")
        )
      );
    } else {
      setRoutes(routesList);
    }
  }, [userData]);

  const SubListItem = ({ key, sub }) => (
    <Dropdown.Item key={sub.id}>
      <h4 style={{ marginTop: 0, marginBottom: 0 }}>
        {i18n.language == "ar" ? sub.titleAr : sub.titleEn}
      </h4>
      {!!sub.subCategories && !!sub.subCategories.length && (
        <SubListMenu catItems={sub} />
      )}
    </Dropdown.Item>
  );

  const SubListMenu = ({ catItems }) => (
    <Dropdown.Submenu position="right">
      {!!catItems.subCategories &&
        !!catItems.subCategories.length &&
        catItems.subCategories.map((sub) => (
          <>
            <SubListItem sub={sub} key={sub.id} />
          </>
        ))}
    </Dropdown.Submenu>
  );

  const drawer = (
    <div>
      <Toolbar>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            flex: 1,
            width: "100%",
          }}
        >
          <IconButton
            sx={{ mr: 2, maxHeight: 80 }}
            size="medium"
            onClick={() => history.replace("/")}
            style={{ alignSelf: "center", margin: "0 auto" }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ display: { xs: "block", sm: "block" } }}
            >
              <Image
                alt={"logo"}
                src={Logo}
                style={{ width: 100, height: 100 }}
              />
            </Typography>
          </IconButton>
        </div>
      </Toolbar>
      <Divider />
      <List style={{ paddingTop: 30, position: 'relative' }}>
        {!!categories && !!categories.length && (
          <ListItem
            key={"all-categories"}
            style={{
              alignSelf: "center",
              margin: "15px auto",
              width: "55%",
            }}
            disablePadding
          >
            <Dropdown
              menuClassName="menu-x"
              // wrapperClassName="wrapper-x"
              style={{
                backgroundColor: theme.light.primary,
                color: theme.light.dark,
              }}
              position="right"
              title="All Categories"
            >
              {categories.map((cat) => (
                <>
                  <Dropdown.Item
                    onClick={() => {
                      history.push(
                        `/categories/${cat.id}?ic=${new Date().getTime()}`
                      );
                    }}
                    key={cat.id}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        flex: 1,
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        alt={cat.titleEn}
                        src={cat.image}
                        sx={{ width: 24, height: 24 }}
                        style={{ margin: "0 10px" }}
                      />
                      <h4 style={{ marginTop: 0, marginBottom: 0 }}>
                        {i18n.language == "ar" ? cat.titleAr : cat.titleEn}
                      </h4>
                    </div>
                    {!!cat.subCategories && !!cat.subCategories.length && (
                      <SubListMenu catItems={cat} />
                    )}
                  </Dropdown.Item>
                </>
              ))}
            </Dropdown>
          </ListItem>
        )}
        {routes.map((route, index) => (
          <>
            {route.key == "screens.translation" && (
              <>
                <Divider />
                <ListItem key={route.key} disablePadding>
                  <ListItemButton
                    disabled={route.isDisabled}
                    onClick={() => changeLanguage()}
                  >
                    <ListItemIcon style={{ color: theme.light.primary }}>
                      {route.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={`${i18n.language === "en" ? "Ar" : "En"}`}
                    />
                  </ListItemButton>
                </ListItem>
              </>
            )}
            {route.key != "screens.translation" && (
              <>
                <ListItem key={route.key} disablePadding>
                  <ListItemButton
                    disabled={route.isDisabled}
                    onClick={() => {
                      if (route.key === "screens.logout") {
                        handleLogout();
                      } else {
                        history.push(route.route);
                      }
                    }}
                  >
                    <ListItemIcon style={{ color: theme.light.primary }}>
                      {route.icon}
                    </ListItemIcon>
                    <ListItemText primary={t(route.key)} />
                    {route.key === "screens.notifications" && (
                      <Badge
                        style={{ right: 5 }}
                        showZero
                        badgeContent={userNotifications?.length ?? 0}
                        color="error"
                      />
                    )}
                    {route.key === "screens.offers" && (
                      <Badge
                        style={{ right: 5 }}
                        showZero
                        badgeContent={
                          offers?.filter((item) => !item.isExpired).length ?? 0
                        }
                        color="error"
                      />
                    )}
                    {route.key === "screens.favourite" && (
                      <Badge
                        style={{ right: 5 }}
                        showZero
                        badgeContent={userFavProducts?.length ?? 0}
                        color="error"
                      />
                    )}
                    {route.key === "screens.contact-us" && (
                      <Badge
                        style={{ right: 5 }}
                        showZero
                        badgeContent={userMessagesCount ?? 0}
                        color="error"
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              </>
            )}
          </>
        ))}
      </List>
      {/* <Divider /> */}
      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List> */}
    </div>
  );

  //   const drawer = (
  //     <div>
  //       <Toolbar />
  //       <Divider />
  //       <List>
  //         {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
  //           <ListItem key={text} disablePadding>
  //             <ListItemButton>
  //               <ListItemIcon>
  //                 {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
  //               </ListItemIcon>
  //               <ListItemText primary={text} />
  //             </ListItemButton>
  //           </ListItem>
  //         ))}
  //       </List>
  //       <Divider />
  //       <List>
  //         {["All mail", "Trash", "Spam"].map((text, index) => (
  //           <ListItem key={text} disablePadding>
  //             <ListItemButton>
  //               <ListItemIcon>
  //                 {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
  //               </ListItemIcon>
  //               <ListItemText primary={text} />
  //             </ListItemButton>
  //           </ListItem>
  //         ))}
  //       </List>
  //     </div>
  //   );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <NavBar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      {/* <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Responsive drawer
          </Typography>
        </Toolbar>
      </AppBar> */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}

ResponsiveNewDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveNewDrawer;
